import React from 'react';
import SubStage from '../SubStage/SubStage'
import PropTypes, { InferProps } from 'prop-types';
import Container from 'react-bootstrap/Container';

const propTypes = {
  name: PropTypes.string,
  subStages: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string.isRequired,
      categories: PropTypes.array,
    })
  ),
  isChecked: PropTypes.func,
  toggleCategory: PropTypes.func,
  setQuantity: PropTypes.func,
  scroll: PropTypes.func.isRequired,
}

export default function Stage(props: InferProps<typeof propTypes>): JSX.Element {
  const { name, subStages, isChecked, toggleCategory, setQuantity, scroll } = props;

  React.useEffect(() => {
    scroll();
  }, []);

  return (
    <div className="stage">
      <h3 className="stage-header">{name}</h3>
      <Container fluid>
        {subStages.map((obj, index) =>
          <SubStage
            name={obj.name}
            categories={obj.categories}
            isChecked={isChecked}
            toggleCategory={toggleCategory}
            setQuantity={setQuantity}
            key={obj.name + index}
          />
        )}
      </Container>
    </div>
  );
}
